import { TFunction } from 'i18next';
import createNowIcon from 'assets/images/order_now.png';
import orderHistoryIcon from 'assets/images/order_history.png';
import { MenuItem } from 'types/common';
import couponIcon from 'assets/images/coupon.png';
import expiredIcon from 'assets/images/expired.png';


export const createMainMenuItems = (t: TFunction): MenuItem[] => {

  return [
    {
      key: 'redeem',
      label: t('menu.redeem')
    },
    {
      key: 'wallet',
      label: t('menu.wallet'),
      children: [
        {
          key: 'coupons-and-vouchers',
          label: t('menu.coupon'),
          icon: <img src={couponIcon} alt="Order Now" className='vls-menu-icon' />,
        },
        {
          key: 'expired-and-used',
          label: t('menu.expired'),
          icon: <img src={expiredIcon} alt="Order History" className='vls-menu-icon' />,

        },

      ],
    },
    {
      key: 'order',
      label: t('menu.pickUpService'),
      children: [
        {
          key: 'create-order',
          label: t('menu.orderNow'),
          icon: <img src={createNowIcon} alt="Order Now" className='vls-menu-icon' />,
        },
        {
          key: 'order-history',
          label: t('menu.orderHistory'),
          icon: <img src={orderHistoryIcon} alt="Order History" className='vls-menu-icon' />,

        },
      ],
    },
    {
      key: 'tips',
      label: t('menu.laundryTips'),
    },
  ];
};

export const createProfileMenuItems = (t: TFunction): MenuItem[] => {
  return [
    {
      key: 'profile',
      label: t('menu.profile'),
    },
    {
      key: 'benefits',
      label: t('menu.membershipScheme'),
    },
  ];
};

export const createSignOutMenuItems = (t: TFunction): MenuItem[] => {
  return [
    {
      key: 'signOut',
      label: t('menu.signOut'),
    },
  ];
};